export const BAILEY_LOOKS = [
    { id: 'original', name: 'The original', detail: 'Warm stone. Beu tee. All you.', colour: '#c9c1b5' },
    { id: 'fade', name: 'Fresh fade', detail: 'A textured crop and clean sides.', colour: '#33302d' },
    { id: 'curls', name: 'Colour play', detail: 'Coral and lilac, with a little attitude.', colour: '#cf8d9c' },
    { id: 'bob', name: 'After hours', detail: 'A sharp bob, blue liner and berry nails.', colour: '#626daa' }
];

export function normaliseLook(value) {
    return BAILEY_LOOKS.some(look => look.id === value) ? value : 'original';
}

export function getBaileyState({ sending, busyApproval, error, waiting, completed, attentive }) {
    if (sending || busyApproval) return 'working';
    if (error) return 'error';
    if (waiting) return 'needs-input';
    if (completed) return 'complete';
    if (attentive) return 'attentive';
    return 'idle';
}

export const STATE_LABELS = {
    idle: 'Ready when you are',
    attentive: 'Ready when you are',
    working: 'Working on it',
    'needs-input': 'Waiting for your decision',
    complete: 'Reply ready',
    error: 'Something needs another try',
    ponder: 'Thinking of ideas',
    idea: 'Has an idea'
};
